/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
    return {
        textColor: '#333333',
        textColor1: '#C4C4C4',
        primary: {
            main: '#0991FF',
            darker1: '#0076D6',
            darker2: '#005AA3',
            lighter1: '#3DA8FF',
            lighter2: '#70BFFF'
        },
        secondary: {
            main: '#000',
            main1: '#D92627',
            darker1: '#AE1E1F',
            darker2: '#831717',
            lighter1: '#E15152',
            lighter2: '#E97C7D'
        },
        background1: '#faf9f9',
        background2: '#f0f0f0',
        jjj: '#fff'
    };
}
